const LedgerReviewFilterStyle = theme => ({
    paddingTop: { paddingTop: theme.spacing(3) },
    justifyRight: { justifyContent: 'flex-end', width: 'auto' },
});

export default LedgerReviewFilterStyle;
